<template>
  <div class="details-of-commission" @click.capture="isShowSel = false">
    <div class="details-top">
      <div class="select" @click="isShowSel = true">
        {{ dateTimeLabel }}
        <i class="fa-caret-up"></i>
        <!-- <div class="select-list" :class="{
            show: isShowSel
        }">
                    <div class="item" :class="{
                select: value == index
            }" v-for="(item, index) in options" :key="item.value" @click="value = index">{{item.label}}</div>
                </div> -->
      </div>
      <div>收入： ￥{{ numberFormat(fractionFormat(income)) }}</div>
    </div>
    <div class="details-body">
      <ul class="message-list">
        <li class="item" v-for="(item, index) in messageList" :key="index">
          <div v-if="item.type == 0">
            <span class="user">{{ item.name }}</span>
            首次激活"
            <span class="important-text">{{ item.pname }}</span
            >",获得
            <span class="important-text"
              >￥{{ fractionFormat(item.commission) }}</span
            >
            佣金
          </div>
          <div v-if="item.type == 1">
            <span class="user">{{ item.name }}</span>
            续费"
            <span class="important-text">{{ item.pname }}</span
            >",获得
            <span class="important-text"
              >￥{{ fractionFormat(item.commission) }}</span
            >
            佣金
          </div>
          <div v-if="item.type == 2">
            <span class="user">{{ item.name }}</span>
            退款了"
            <span class="important-text">{{ item.pname }}</span
            >",扣除
            <span class="important-text"
              >￥{{ fractionFormat(item.commission) }}</span
            >
            佣金
          </div>
          <div v-if="item.type == 3">
            成功提现
            <span class="important-text"
              >￥{{ fractionFormat(item.commission) }}</span
            >
            到支付宝
          </div>
          <div class="time">
            {{ new Date(item.time * 1000).pattern("MM/dd HH:mm") }}
          </div>
        </li>
      </ul>
      <div class="no-data" v-if="!messageList.length">无记录</div>
    </div>
    <popup get-container=".wrap" v-model="isShowSel" position="bottom">
      <datetime-picker
        v-model="currentTime"
        type="year-month"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="timeSel"
        @cancel="timeCancel"
      />
    </popup>
  </div>
</template>

<script>
import { getAgentdetail } from "@/api/index";
import { amountData } from "@/mixins/amountData";
import { DatetimePicker, Popup } from "vant";
import "vant/lib/datetime-picker/style";
import "vant/lib/popup/style";
import "@vant/touch-emulator";
export default {
  mixins: [amountData],
  data() {
    return {
      value: 0,
      options: [
        {
          value: "thismonth",
          label: "本月",
        },
        {
          value: "thisweek",
          label: "本周",
        },
        {
          value: "today",
          label: "本日",
        },
      ],
      starttime: new Date().setTime(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      ),
      currentTime: new Date(),
      endtime: new Date(),
      maxDate: new Date(),
      messageList: [
        // {
        //     user: "李小帅",
        //     type: "open",
        //     time: "11/14 14:04"
        // },
        // {
        //     user: "李小帅",
        //     type: "buy",
        //     number: 1,
        //     commodityType: "电脑版季卡",
        //     commission: 28.7,
        //     time: "11/14 13:04"
        // }
      ],
      isShowSel: false,
      income: 0,
    };
  },
  computed: {
    dateTimeLabel() {
      if (new Date(this.starttime).getMonth() == new Date().getMonth()) {
        return "本月";
      } else {
        return `${new Date(this.starttime).getFullYear()}-${new Date(
          this.starttime
        ).getMonth() + 1}月`;
      }
    },
  },
  components: {
    DatetimePicker,
    Popup,
  },
  created() {
    this.getAgentdetail();
  },
  methods: {
    getAgentdetail() {
      getAgentdetail({
        starttime: Math.round(this.starttime / 1000),
        endtime: Math.round(this.endtime / 1000),
      }).then((res) => {
        if (res.code == 0) {
          let data = res.data;
          this.income = data.commission;
          this.messageList = data.record;
        }
        if (res.code == -2) {
          this.$message({
            dangerouslyUseHTMLString: true,
            type: "error",
            message:
              '<strong>查询失败</strong><p style="margin-top: 5px;">查询时间段过长</p>',
          });
        }
      });
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    timeSel(val) {
      if (val >= this.maxDate) {
        this.starttime = new Date().setTime(
          new Date(new Date().getFullYear(), new Date().getMonth(), 1)
        );
      } else {
        this.starttime = val;
      }
      this.currentTime = this.starttime;
      let lastDay = new Date(this.starttime);
      lastDay.setMonth(lastDay.getMonth() + 1);
      this.endtime = lastDay;
      this.getAgentdetail();
      this.isShowSel = false;
    },
    timeCancel() {
      this.isShowSel = false;
    },
  },
};
</script>

<style lang="less" scoped>
.details-of-commission {
  color: #101010;
  height: 100%;
  background: #f2f2f2;
  .user {
    color: #21a0ff;
  }
  .important-text {
    color: #ffa500;
  }
  .details-top {
    height: 36px;
    line-height: 36px;
    display: flex;
    justify-content: space-between;
    padding: 0 14px;
    .fa-caret-up {
      transform-origin: center;
      transform: rotate(180deg);
      transition: 1s;
      &.sel {
        transform: rotate(0deg);
      }
    }
    .select-list {
      display: none;
      transition: 1s;
      overflow: hidden;
      border: 1px solid #ccc;
      text-align: center;
      border-radius: 2px;
      margin-top: 2px;
      margin-left: -10px;
      background: #fff;
      position: relative;
      &.show {
        display: block;
      }
      .item {
        padding: 0 20px;
        &.select {
          color: #409eff;
          font-weight: 700;
          background: #f5f7fa;
        }
      }
    }
  }
  .details-body {
    height: calc(~"100% - 36px");
    overflow: auto;
    .message-list {
      margin: 0;
      .item {
        background: #fff;
        padding: 14px;
        margin-bottom: 10px;
        line-height: 26px;
        .time {
          text-align: right;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
